export const qaApi = {
    list: {
        method: 'post',
        api: 'admin/qa/list'
    },
    add: {
      method: 'post',
      api: 'admin/qa/add'
    },
    edit: {
        method: 'post',
        api: 'admin/qa/edit'
    },
    get: {
      method: 'post',
      api: 'admin/qa/get'
    },
    del: {
      method: 'post',
      api: 'admin/qa/del'
    },
  }